/* eslint-disable @typescript-eslint/no-namespace */
export namespace Session {
  export interface Claims {
    sub: number | string;
    deptId: number;
    firmId: number;
    deptType: DeptType;
    name: string;
    email: string;
    persona: Persona;
    websocketGatewaySession: {
      isEstablished: boolean;
      token: string;
    };
  }

  export enum Persona {
    Adv = 'Adv', // gamedayfa
    Analyst = 'Analyst',
    BranchMgr = 'BranchMgr', // gamedaybmgr
    SyndDesk = 'SyndDesk',
    DeskAdmin = 'DeskAdmin',
    UW = 'UW',
    Sales = 'Sales',
    Treas = 'Treas', // gamedayissuer
  }

  export enum DeptType {
    SyndDesk = 'SyndDesk',
    // ToDo: Add more later
  }
  export interface SessionModel extends Claims {
    token?: string;
  }
}
